import { toast } from 'react-toastify';

// Standardized toast configurations
// Note: Don't set position here to avoid overriding global ToastContainer settings
export const toastConfig = {
  success: {
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    theme: "light" as const,
  },
  error: {
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    theme: "light" as const,
    className: "bg-error fw-semibold",
  }
};

// Standardized toast functions
export const showSuccessToast = (message: string, toastId?: string) => {
  return toast.success(message, {
    ...toastConfig.success,
    toastId: toastId || undefined,
  });
};

export const showErrorToast = (message: string, toastId?: string) => {
  return toast.error(message, {
    ...toastConfig.error,
    toastId: toastId || undefined,
  });
};

// Function to dismiss all toasts
export const dismissAllToasts = () => {
  toast.dismiss();
};

// Function to dismiss specific toast
export const dismissToast = (toastId: string) => {
  toast.dismiss(toastId);
};
